<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerList",
  data() {
    return {
      baseUrl: 'custom',
      breadcrumb: [
        { name: "承运管理" },
        { name: "承运商管理" },
      ],
      menuIndex: `/carrier/manage/table/1`,
      menu: [
        {
          name: "在用",
          path: `/carrier/manage/table/1`,
        },
        {
          name: "停用",
          path: `/carrier/manage/table/2`,
        },
      ],
    };
  },
  computed: {},
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
<style lang="less" scoped></style>